import React from "react";
import getInspectionPhoneLink from "../getInspectionPhoneLink";

interface InspectionPhoneLinkProps {
  phone: string;
}
export default function InspectionPhoneLink({ phone }: InspectionPhoneLinkProps) {
  const link = getInspectionPhoneLink(phone);
  return <a href={`tel:${link}`}>{phone}</a>;
}
